/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Profile/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import ProfileData from './ProfileData/index'
import ProfileImage from './ProfileImage/index'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Profile({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Postal/Addresses/Content/Address/Edit/Content/EditOrAdd/Content/Content/Profiles/Content/Profile"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let selectedContactMethodAssociationIdsValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'contact_method_association_ids',
})
let personContactMethodAssociationIdValueData = fromData.useDataValue({ viewPath,
context: 'person',
path: 'contact_method_association_id',
})
let aggregateData = fromAggregate.includes(selectedContactMethodAssociationIdsValueData, personContactMethodAssociationIdValueData)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Profile.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-1AREyJ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 marginRight={dtSpaceXs}
 data="selected.contact_method_association_ids"
 data="person.contact_method_association_id"
 aggregate="/Data/aggregate.js includes"
 value={aggregateData}
 onChange={onChange}
>
{childProps => (
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
/>
)}
</TysiaCheckbox>
<ProfileImage
  viewPath={`${viewPath}/ProfileImage`}
/>
<div
  data-testid="Profile.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<ProfileData
  viewPath={`${viewPath}/ProfileData`}
/>
</div>
</div>
{children}
</React.Fragment>)
}